import { Component, Input, OnInit } from '@angular/core';
import { environment } from '@environment';

@Component({
  selector: 'app-supporters-info',
  templateUrl: './supporters-info.component.html',
  styleUrls: ['./supporters-info.component.scss']
})
export class SupportersInfoComponent implements OnInit {

  @Input() fundraiser;
  supporterImg;

  constructor() { }

  ngOnInit(): void {
    this.supporterImg = `/assets/images/random_supporters/${Math.floor(Math.random() * 10) + 1}.png`;
  }

}
